// import React, { useEffect, useRef, useState } from 'react';
// import {
//     MapContainer,
//     TileLayer,
//     Marker,
//     useMapEvents,
//     useMap
// } from 'react-leaflet';
// import L, { LatLngExpression, Map as LeafletMap } from 'leaflet';
// import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
// import 'leaflet/dist/leaflet.css';
// import './style.css';
// import {Col, Form} from "react-bootstrap";
//
// type Location = {
//     lat: number;
//     lng: number;
//     address: string;
// };
//
// interface MapWrapperProps {
//     location: Location;
//     setLocation: (loc: Location) => void;
// }
//
// const ClickableMap: React.FC<{ setLocation: (loc: Location) => void }> = ({ setLocation }) => {
//     const map = useMap();
//
//     useMapEvents({
//         click(e) {
//             // Don't handle clicks when interacting with search elements
//             const target = e.originalEvent.target as HTMLElement;
//             if (target.closest('.leaflet-control-geosearch')) {
//                 return;
//             }
//
//             const { lat, lng } = e.latlng;
//
//             // First update with coordinates only
//             setLocation({
//                 lat: lat,
//                 lng: lng,
//                 address: 'Fetching address...'
//             });
//
//             // Perform reverse geocoding to get address
//             reverseGeocode(lat, lng)
//                 .then(address => {
//                     setLocation({
//                         lat: lat,
//                         lng: lng,
//                         address: address
//                     });
//                 })
//                 .catch(err => {
//                     console.error('Error getting address:', err);
//                     setLocation({
//                         lat: lat,
//                         lng: lng,
//                         address: 'Address not found'
//                     });
//                 });
//
//             // Adjust the zoom level slightly when clicking on the map
//             if (map.getZoom() < 14) {
//                 map.setZoom(14);
//             }
//         }
//     });
//     return null;
// };
//
// // Function to perform reverse geocoding
// const reverseGeocode = async (lat: number, lng: number): Promise<string> => {
//     try {
//         const response = await fetch(
//             `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`,
//             {
//                 headers: {
//                     'Accept-Language': 'en-US,en;q=0.9',
//                     'User-Agent': 'MapLocation/1.0'
//                 }
//             }
//         );
//
//         if (!response.ok) {
//             throw new Error('Failed to fetch address');
//         }
//
//         const data = await response.json();
//
//         if (data && data.display_name) {
//             return data.display_name;
//         } else {
//             return 'Address not found';
//         }
//     } catch (error) {
//         console.error('Reverse geocoding error:', error);
//         return 'Address not found';
//     }
// };
//
// const SearchField: React.FC<{ setLocation: (loc: Location) => void }> = ({ setLocation }) => {
//     const map = useMap();
//
//     useEffect(() => {
//         const provider = new OpenStreetMapProvider({
//             params: {
//                 'accept-language': 'en', // Set language for results
//                 countrycodes: '', // Optional: limit search to specific countries
//                 addressdetails: 1,
//                 format: 'json'
//             }
//         });
//
//         const searchControl = new GeoSearchControl({
//             provider,
//             showMarker: false, // Don't show the search control's marker
//             showPopup: false,
//             style: 'bar',
//             searchLabel: 'Enter address',
//             keepResult: true,
//             autoComplete: true,
//             autoCompleteDelay: 250,
//             retainZoomLevel: false,
//             animateZoom: true,
//             autoClose: false,
//             position: 'topleft',
//             // Disable the built-in reverse geocoding to prevent the bad request
//             showUniqueResult: true,
//             maxSuggestions: 5,
//         });
//
//         map.addControl(searchControl);
//
//         // Fix for search bar click issue
//         const stopPropagation = (e: Event) => {
//             e.stopPropagation();
//         };
//
//         // Add event listeners to prevent search control clicks from being captured by the map
//         const searchElements = document.querySelectorAll('.leaflet-control-geosearch input, .leaflet-control-geosearch button');
//         searchElements.forEach(el => {
//             el.addEventListener('click', stopPropagation);
//             el.addEventListener('mousedown', stopPropagation);
//             el.addEventListener('touchstart', stopPropagation);
//         });
//
//         // Custom handler for search results - using our own logic, not the built-in reverse geocoding
//         map.on('geosearch/showlocation', (result: any) => {
//             if (result && result.location) {
//                 const { x, y, label } = result.location;
//
//                 // Update location state with the selected coordinates
//                 setLocation({
//                     lat: y,
//                     lng: x,
//                     address: label || '' // Use the label from the search result
//                 });
//
//                 // Center map on selected location with animation and zoom in a bit
//                 map.setView([y, x], 16, {
//                     animate: true,
//                     duration: 0.5
//                 });
//             }
//         });
//
//         return () => {
//             map.removeControl(searchControl);
//             // Clean up event listeners
//             searchElements.forEach(el => {
//                 el.removeEventListener('click', stopPropagation);
//                 el.removeEventListener('mousedown', stopPropagation);
//                 el.removeEventListener('touchstart', stopPropagation);
//             });
//         };
//     }, [map, setLocation]);
//
//     return null;
// };
//
// const MapWrapper: React.FC<MapWrapperProps> = ({ location, setLocation }) => {
//     const position: LatLngExpression = [location.lat, location.lng];
//     const mapRef = useRef<LeafletMap | null>(null);
//     const [errorMsg, setErrorMsg] = useState<string | null>(null);
//     const markerRef = useRef<L.Marker | null>(null);
//
//     // Create a custom icon with adjusted anchor point to position marker correctly
//     const customIcon = L.icon({
//         iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
//         iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
//         shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
//         iconSize: [25, 41],
//         iconAnchor: [12, 41], // Horizontal center, bottom of the icon
//         popupAnchor: [1, -34],
//         tooltipAnchor: [16, -28],
//         shadowSize: [41, 41]
//     });
//
//     // Clear error message after 5 seconds
//     useEffect(() => {
//         if (errorMsg) {
//             const timer = setTimeout(() => {
//                 setErrorMsg(null);
//             }, 5000);
//             return () => clearTimeout(timer);
//         }
//     }, [errorMsg]);
//
//     return (
//         <div className="map-container-wrapper">
//             <Form.Group controlId='exampleForm.ControlInput1'>
//                 <Form.Label className='text-muted'>Work Site Location</Form.Label>
//             </Form.Group>
//
//             {errorMsg && (
//                 <div className="map-error-message">{errorMsg}</div>
//             )}
//             <div>Please press enter after selecting the location on the suggestions.</div>
//             <MapContainer
//                 style={{ height: '400px', width: '100%' }}
//                 center={position}
//                 zoom={17}
//                 scrollWheelZoom={false}
//                 ref={mapRef}
//             >
//                 <TileLayer
//                     attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
//                     url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
//                 />
//                 <Marker
//                     position={position}
//                     icon={customIcon}
//                     ref={markerRef}
//                     draggable={true}
//                 />
//                 <ClickableMap setLocation={setLocation} />
//                 <SearchField
//                     setLocation={(loc) => {
//                         try {
//                             setLocation(loc);
//                             setErrorMsg(null);
//                         } catch (e) {
//                             setErrorMsg("Error selecting location. Please try again.");
//                             console.error("Location selection error:", e);
//                         }
//                     }}
//                 />
//             </MapContainer>
//         </div>
//     );
// };
//
// export default MapWrapper;


import React, { useEffect, useRef, useState } from 'react';
import {
    MapContainer,
    TileLayer,
    Marker,
    useMapEvents,
    useMap
} from 'react-leaflet';
import L, { LatLngExpression, Map as LeafletMap } from 'leaflet';
import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import 'leaflet/dist/leaflet.css';
import './style.css';
import {Col, Form} from "react-bootstrap";

type Location = {
    lat: number;
    lng: number;
    address: string;
};

interface MapWrapperProps {
    location: Location;
    setLocation: (loc: Location) => void;
}

const ClickableMap: React.FC<{ setLocation: (loc: Location) => void }> = ({ setLocation }) => {
    const map = useMap();

    useMapEvents({
        click(e) {
            // Don't handle clicks when interacting with search elements
            const target = e.originalEvent.target as HTMLElement;
            if (target.closest('.leaflet-control-geosearch')) {
                return;
            }

            const { lat, lng } = e.latlng;

            // First update with coordinates only
            setLocation({
                lat: lat,
                lng: lng,
                address: 'Fetching address...'
            });

            // Perform reverse geocoding to get address
            reverseGeocode(lat, lng)
                .then(address => {
                    setLocation({
                        lat: lat,
                        lng: lng,
                        address: address
                    });
                })
                .catch(err => {
                    console.error('Error getting address:', err);
                    setLocation({
                        lat: lat,
                        lng: lng,
                        address: 'Address not found'
                    });
                });

            // Adjust the zoom level slightly when clicking on the map
            if (map.getZoom() < 14) {
                map.setZoom(14);
            }
        }
    });
    return null;
};

// Function to perform reverse geocoding
const reverseGeocode = async (lat: number, lng: number): Promise<string> => {
    try {
        const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`,
            {
                headers: {
                    'Accept-Language': 'en-US,en;q=0.9',
                    'User-Agent': 'MapLocation/1.0'
                }
            }
        );

        if (!response.ok) {
            throw new Error('Failed to fetch address');
        }

        const data = await response.json();

        if (data && data.display_name) {
            return data.display_name;
        } else {
            return 'Address not found';
        }
    } catch (error) {
        console.error('Reverse geocoding error:', error);
        return 'Address not found';
    }
};

const SearchField: React.FC<{ setLocation: (loc: Location) => void }> = ({ setLocation }) => {
    const map = useMap();

    useEffect(() => {
        const provider = new OpenStreetMapProvider({
            params: {
                'accept-language': 'en', // Set language for results
                countrycodes: '', // Optional: limit search to specific countries
                addressdetails: 1,
                format: 'json'
            }
        });

        const searchControl = new GeoSearchControl({
            provider,
            showMarker: false,
            showPopup: false,
            style: 'bar',
            searchLabel: 'Enter address',
            keepResult: false,
            autoComplete: true,
            autoCompleteDelay: 250,
            retainZoomLevel: false,
            animateZoom: true,
            autoClose: false,
            position: 'topleft',
            showUniqueResult: true,
            maxSuggestions: 5,
            onShowLocation: () => {console.log("Search")}, // <-- KEY FIX
        });

        map.addControl(searchControl);

        // Fix for search bar click issue
        const stopPropagation = (e: Event) => {
            e.stopPropagation();
        };

        // Add event listeners to prevent search control clicks from being captured by the map
        const searchElements = document.querySelectorAll('.leaflet-control-geosearch input, .leaflet-control-geosearch button');
        searchElements.forEach(el => {
            el.addEventListener('click', stopPropagation);
            el.addEventListener('mousedown', stopPropagation);
            el.addEventListener('touchstart', stopPropagation);
        });

        // Custom handler for search results - using our own logic, not the built-in reverse geocoding
        map.on('geosearch/showlocation', (result: any) => {
            if (result && result.location) {
                const { x, y, label, lat, lng } = result.location;
                const latitude = lat ?? y;
                const longitude = lng ?? x;

                // Update location state with the selected coordinates
                setLocation({
                    lat: latitude,
                    lng: longitude,
                    address: label || '' // Use the label from the search result
                });

                // Center map on selected location with animation and zoom in a bit
                map.setView([latitude, longitude], 16, {
                    animate: true,
                    duration: 0.5
                });

                // Explicitly ensure dragging is enabled after search operation
                if (map.dragging && !map.dragging.enabled()) {
                    map.dragging.enable();
                }
            }
        });

        return () => {
            map.removeControl(searchControl);
            // Clean up event listeners
            searchElements.forEach(el => {
                el.removeEventListener('click', stopPropagation);
                el.removeEventListener('mousedown', stopPropagation);
                el.removeEventListener('touchstart', stopPropagation);
            });
        };
    }, [map, setLocation]);

    return null;
};

// This component ensures that the map remains draggable
const MapStateMaintainer: React.FC = () => {
    const map = useMap();

    useEffect(() => {
        // Ensure dragging is always enabled
        if (map && map.dragging) {
            map.dragging.enable();
        }

        // Re-enable dragging after map state changes
        const handleEvent = () => {
            if (map && map.dragging && !map.dragging.enabled()) {
                map.dragging.enable();
            }
        };

        // Listen for events that might affect draggability
        map.on('zoomend', handleEvent);
        map.on('moveend', handleEvent);
        map.on('click', handleEvent);

        return () => {
            map.off('zoomend', handleEvent);
            map.off('moveend', handleEvent);
            map.off('click', handleEvent);
        };
    }, [map]);

    return null;
};

// Draggable marker handler
const DraggableMarker: React.FC<{ position: LatLngExpression, setLocation: (loc: Location) => void, customIcon: L.Icon }> =
    ({ position, setLocation, customIcon }) => {
        const markerRef = useRef<L.Marker | null>(null);

        useEffect(() => {
            if (markerRef.current) {
                markerRef.current.on('dragend', function() {
                    const marker = markerRef.current;
                    if (marker) {
                        const position = marker.getLatLng();
                        // Update location when marker is dragged
                        setLocation({
                            lat: position.lat,
                            lng: position.lng,
                            address: 'Fetching address...'
                        });

                        // Get address for new position
                        reverseGeocode(position.lat, position.lng)
                            .then(address => {
                                setLocation({
                                    lat: position.lat,
                                    lng: position.lng,
                                    address: address
                                });
                            })
                            .catch(err => {
                                console.error('Error getting address:', err);
                                setLocation({
                                    lat: position.lat,
                                    lng: position.lng,
                                    address: 'Address not found'
                                });
                            });
                    }
                });
            }

            return () => {
                if (markerRef.current) {
                    markerRef.current.off('dragend');
                }
            };
        }, [setLocation]);

        return <Marker position={position} icon={customIcon} ref={markerRef} draggable={true} />;
    };

const MapWrapper: React.FC<MapWrapperProps> = ({ location, setLocation }) => {
    const position: LatLngExpression = [location.lat, location.lng];
    const mapRef = useRef<LeafletMap | null>(null);
    const [errorMsg, setErrorMsg] = useState<string | null>(null);

    // Create a custom icon with adjusted anchor point to position marker correctly
    const customIcon = L.icon({
        iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
        iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
        shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41], // Horizontal center, bottom of the icon
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41]
    });

    // Clear error message after 5 seconds
    useEffect(() => {
        if (errorMsg) {
            const timer = setTimeout(() => {
                setErrorMsg(null);
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [errorMsg]);

    // Function to handle the map ref and ensure dragging is enabled
    const handleMapRef = (map: LeafletMap | null) => {
        mapRef.current = map;
        if (map && map.dragging) {
            map.dragging.enable();
        }
    };

    return (
        <div className="map-container-wrapper">
            <Form.Group controlId='exampleForm.ControlInput1'>
                <Form.Label className='text-muted'>Work Site Location</Form.Label>
            </Form.Group>

            {errorMsg && (
                <div className="map-error-message">{errorMsg}</div>
            )}
            <div>Please click the search field and press enter after selecting the location on the suggestions.</div>
            <MapContainer
                style={{ height: '400px', width: '100%' }}
                center={position}
                zoom={17}
                scrollWheelZoom={false}
                ref={handleMapRef}
                dragging={true}
                // whenCreated={(map) => {
                //     // Ensure dragging is enabled when map is created
                //     if (map.dragging) {
                //         map.dragging.enable();
                //     }
                // }}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <DraggableMarker
                    position={position}
                    setLocation={setLocation}
                    customIcon={customIcon}
                />
                <ClickableMap setLocation={setLocation} />
                <SearchField
                    setLocation={(loc) => {
                        try {
                            setLocation(loc);
                            setErrorMsg(null);
                            // Ensure map remains draggable after search
                            if (mapRef.current && mapRef.current.dragging) {
                                mapRef.current.dragging.enable();
                            }
                        } catch (e) {
                            setErrorMsg("Error selecting location. Please try again.");
                            console.error("Location selection error:", e);
                        }
                    }}
                />
                <MapStateMaintainer />
            </MapContainer>
        </div>
    );
};

export default MapWrapper;